"use strict";

// ============================================================
// TIENDA
//
// Archivo:
// src/fronend/Egresos/tienda/tienda.js
//
// URL TABLA:
// /tienda/listar
//
// URL DROPDOWN EMPLEADOS:
// /tienda/listartienda
//
// URL GUARDAR:
// /tienda/guardar
//
// URL ACTUALIZAR:
// /tienda/actualizar
//
// URL ELIMINAR:
// /tienda/eliminar
//
// VISTA DROPDOWN:
// dbo.LISTARdescuentoempleado
//
// PROCEDIMIENTO GUARDAR:
// dbo.SP_TIENDA_I
//
// PROCEDIMIENTO ACTUALIZAR:
// dbo.SP_TIENDA_U
//
// PROCEDIMIENTO ELIMINAR:
// dbo.SP_TIENDA_D
//
// MODAL NUEVO:
// #modalTienda
//
// MODAL EDITAR:
// #modalEditarTienda
//
// FORMULARIO EDITAR:
// #formEditarTienda
//
// ============================================================


// ============================================================
// VARIABLES
// ============================================================

let registrosTienda = [];

let empleadosTienda = [];

let moduloTiendaInicializado = false;


// ============================================================
// INICIALIZAR MÓDULO
// ============================================================

function inicializarTienda() {

    if (moduloTiendaInicializado) {
        return;
    }

    moduloTiendaInicializado = true;

    console.log(
        "🟢 Módulo Descuentos de Tienda iniciado"
    );


    // ========================================================
    // CARGAR REGISTROS
    // ========================================================

    cargarTienda();


    // ========================================================
    // CARGAR EMPLEADOS
    // ========================================================

    cargarEmpleadosTienda();

}


// ============================================================
// CARGAR REGISTROS DE TIENDA
// ============================================================

async function cargarTienda() {

    const tbody =
        document.getElementById(
            "tbodyTienda"
        );


    if (!tbody) {

        console.error(
            "❌ No existe el elemento #tbodyTienda"
        );

        return;

    }


    tbody.innerHTML = `
        <tr>

            <td
                colspan="12"
                class="loading">

                <div
                    class="spinner-border text-success me-2"
                    role="status">
                </div>

                Cargando descuentos de tienda...

            </td>

        </tr>
    `;


    try {

        const respuesta =
            await fetch(
                "/tienda/listar",
                {
                    method: "GET",
                    headers: {
                        "Content-Type":
                            "application/json"
                    }
                }
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        console.log(
            "📦 Respuesta /tienda/listar:",
            resultado
        );


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudieron cargar los registros"
            );

        }


        registrosTienda =
            Array.isArray(
                resultado.data
            )
                ? resultado.data
                : [];


        console.log(
            "✅ Registros de tienda:",
            registrosTienda
        );


        llenarTablaTienda();

        actualizarResumenTienda();


    } catch (error) {

        console.error(
            "❌ Error al cargar descuentos de tienda:",
            error
        );


        registrosTienda = [];


        tbody.innerHTML = `
            <tr>

                <td
                    colspan="12"
                    class="empty-state">

                    <i
                        class="bi bi-exclamation-triangle d-block">
                    </i>

                    <div class="fw-semibold">

                        Error al cargar los
                        descuentos de tienda

                    </div>

                    <small>

                        ${escapeHTML(
                            error.message
                        )}

                    </small>

                </td>

            </tr>
        `;

    }

}


// ============================================================
// CARGAR EMPLEADOS PARA DROPDOWN
//
// URL:
// /tienda/listartienda
//
// VISTA:
// dbo.LISTARdescuentoempleado
//
// ============================================================

async function cargarEmpleadosTienda() {

    const select =
        document.getElementById(
            "idEmpleadoTienda"
        );


    if (!select) {

        console.error(
            "❌ No existe #idEmpleadoTienda"
        );

        return;

    }


    select.innerHTML = `
        <option value="">
            Cargando empleados...
        </option>
    `;


    try {

        console.log(
            "🔄 Consultando /tienda/listartienda..."
        );


        const respuesta =
            await fetch(
                "/tienda/listartienda",
                {
                    method: "GET",
                    headers: {
                        "Content-Type":
                            "application/json"
                    }
                }
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        console.log(
            "📦 Respuesta /tienda/listartienda:",
            resultado
        );


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudieron cargar los empleados"
            );

        }


        empleadosTienda =
            Array.isArray(
                resultado.data
            )
                ? resultado.data
                : [];


        console.log(
            "👥 Empleados recibidos:",
            empleadosTienda
        );


        llenarSelectEmpleadosTienda();


    } catch (error) {

        console.error(
            "❌ Error al cargar empleados:",
            error
        );


        empleadosTienda = [];


        select.innerHTML = `
            <option value="">
                Error al cargar empleados
            </option>
        `;

    }

}


// ============================================================
// LLENAR DROPDOWN DE EMPLEADOS
// ============================================================

function llenarSelectEmpleadosTienda() {

    const select =
        document.getElementById(
            "idEmpleadoTienda"
        );


    if (!select) {
        return;
    }


    select.innerHTML = `
        <option value="">
            Seleccione un empleado...
        </option>
    `;


    if (
        !Array.isArray(
            empleadosTienda
        ) ||
        empleadosTienda.length === 0
    ) {

        select.innerHTML = `
            <option value="">
                No hay empleados disponibles
            </option>
        `;

        return;

    }


    empleadosTienda.forEach(
        empleado => {

            const id =
                empleado.IDEMPLEADO;

            const nombre =
                empleado.NOMBREEMPLEADO;


            if (
                id === null ||
                id === undefined ||
                id === ""
            ) {

                return;

            }


            const option =
                document.createElement(
                    "option"
                );


            option.value =
                id;


            option.textContent =
                `${id} - ${nombre ?? ""}`;


            select.appendChild(
                option
            );

        }
    );


    console.log(
        `✅ Dropdown cargado con ${empleadosTienda.length} empleados`
    );

}


// ============================================================
// OBTENER EMPLEADO SELECCIONADO
// ============================================================

function obtenerEmpleadoTienda(
    idEmpleado
) {

    return empleadosTienda.find(
        empleado =>
            String(
                empleado.IDEMPLEADO
            ) ===
            String(
                idEmpleado
            )
    );

}


// ============================================================
// SELECCIONAR EMPLEADO
// ============================================================

function seleccionarEmpleadoTienda() {

    const select =
        document.getElementById(
            "idEmpleadoTienda"
        );


    if (!select) {
        return;
    }


    const idEmpleado =
        select.value;


    console.log(
        "🔎 IDEMPLEADO seleccionado:",
        idEmpleado
    );


    if (!idEmpleado) {

        limpiarDatosEmpleadoTienda();

        return;

    }


    const empleado =
        obtenerEmpleadoTienda(
            idEmpleado
        );


    if (!empleado) {

        console.error(
            "❌ No se encontró el empleado:",
            idEmpleado
        );


        limpiarDatosEmpleadoTienda();

        return;

    }


    console.log(
        "👤 Empleado seleccionado:",
        empleado
    );


    const mostrarId =
        document.getElementById(
            "mostrarIdEmpleadoTienda"
        );


    if (mostrarId) {

        mostrarId.value =
            empleado.IDEMPLEADO ?? "";

    }


    const nombreInput =
        document.getElementById(
            "nombreEmpleadoTienda"
        );


    if (nombreInput) {

        nombreInput.value =
            empleado.NOMBREEMPLEADO ?? "";

    }


    const dpiInput =
        document.getElementById(
            "dpiEmpleadoTienda"
        );


    if (dpiInput) {

        dpiInput.value =
            empleado.DPI ?? "";

    }


    const puestoInput =
        document.getElementById(
            "puestoEmpleadoTienda"
        );


    if (puestoInput) {

        puestoInput.value =
            empleado.NOMBREPUESTO ?? "";

    }


    const direccionInput =
        document.getElementById(
            "direccionEmpleadoTienda"
        );


    if (direccionInput) {

        direccionInput.value =
            empleado.DIRECCION ?? "";

    }


    const salarioInput =
        document.getElementById(
            "salarioBaseTienda"
        );


    if (salarioInput) {

        salarioInput.value =
            empleado.SALARIOBASE ?? "";

    }


    const descuentoInput =
        document.getElementById(
            "descuentoTienda"
        );


    if (descuentoInput) {

        descuentoInput.value = "";

    }


    const pagoInput =
        document.getElementById(
            "pagoPorDescuentoTienda"
        );


    if (pagoInput) {

        pagoInput.value = "";

    }


    const mensaje =
        document.getElementById(
            "mensajeEmpleadosTienda"
        );


    if (mensaje) {

        mensaje.textContent =
            "Datos del empleado cargados correctamente.";

    }

}


// ============================================================
// LIMPIAR DATOS DEL EMPLEADO
// ============================================================

function limpiarDatosEmpleadoTienda() {

    const campos = [

        "mostrarIdEmpleadoTienda",

        "nombreEmpleadoTienda",

        "dpiEmpleadoTienda",

        "puestoEmpleadoTienda",

        "direccionEmpleadoTienda",

        "salarioBaseTienda",

        "descuentoTienda",

        "pagoPorDescuentoTienda"

    ];


    campos.forEach(
        id => {

            const campo =
                document.getElementById(
                    id
                );


            if (campo) {

                campo.value = "";

            }

        }
    );


    const mensaje =
        document.getElementById(
            "mensajeEmpleadosTienda"
        );


    if (mensaje) {

        mensaje.textContent =
            "Seleccione el empleado para cargar sus datos.";

    }

}


// ============================================================
// CALCULAR PAGO POR DESCUENTO
//
// PAGO POR DESCUENTO =
// SALARIO BASE × (DESCUENTO / 100)
//
// ============================================================

function calcularPagoDescuentoTienda() {

    const salarioInput =
        document.getElementById(
            "salarioBaseTienda"
        );


    const descuentoInput =
        document.getElementById(
            "descuentoTienda"
        );


    const pagoInput =
        document.getElementById(
            "pagoPorDescuentoTienda"
        );


    if (
        !salarioInput ||
        !descuentoInput ||
        !pagoInput
    ) {

        return;

    }


    const salario =
        convertirNumero(
            salarioInput.value
        );


    const descuento =
        convertirNumero(
            descuentoInput.value
        );


    if (descuento < 0) {

        pagoInput.value =
            "0.00";

        return;

    }


    const pago =
        salario *
        (
            descuento /
            100
        );


    pagoInput.value =
        pago.toFixed(2);

}


// ============================================================
// GUARDAR DESCUENTO DE TIENDA
//
// URL:
// POST /tienda/guardar
//
// PROCEDIMIENTO:
// dbo.SP_TIENDA_I
//
// ============================================================

async function guardarTienda() {

    console.log(
        "💾 Iniciando guardado de descuento de tienda..."
    );


    const idEmpleado =
        document.getElementById(
            "idEmpleadoTienda"
        );


    const nombreTienda =
        document.getElementById(
            "nombreTienda"
        );


    const descuento =
        document.getElementById(
            "descuentoTienda"
        );


    const pago =
        document.getElementById(
            "pagoPorDescuentoTienda"
        );


    const fecha =
        document.getElementById(
            "fechaTienda"
        );


    const estado =
        document.getElementById(
            "estadoTienda"
        );


    if (
        !idEmpleado ||
        !nombreTienda ||
        !descuento ||
        !pago ||
        !fecha ||
        !estado
    ) {

        console.error(
            "❌ Faltan elementos del formulario de tienda"
        );

        return;

    }


    const valorIdEmpleado =
        idEmpleado.value;


    const valorNombreTienda =
        nombreTienda.value.trim();


    const valorDescuento =
        convertirNumero(
            descuento.value
        );


    const valorPago =
        convertirNumero(
            pago.value
        );


    const valorFecha =
        fecha.value;


    const valorEstado =
        estado.value || "A";


    if (!valorIdEmpleado) {

        alert(
            "Seleccione un empleado."
        );

        idEmpleado.focus();

        return;

    }


    if (!valorNombreTienda) {

        alert(
            "Ingrese el nombre de la tienda."
        );

        nombreTienda.focus();

        return;

    }


    if (valorDescuento <= 0) {

        alert(
            "Ingrese un porcentaje de descuento válido."
        );

        descuento.focus();

        return;

    }


    if (!valorFecha) {

        alert(
            "Seleccione la fecha."
        );

        fecha.focus();

        return;

    }


    const datos = {

        NOMBRETIENDA:
            valorNombreTienda,

        DESCUENTO:
            valorDescuento,

        PAGOPORDESCUENTO:
            valorPago,

        IDEMPLEADO:
            Number(
                valorIdEmpleado
            ),

        FECHA:
            valorFecha,

        ESTADO:
            valorEstado

    };


    console.log(
        "📤 Datos enviados a /tienda/guardar:",
        datos
    );


    const formulario =
        document.getElementById(
            "formTienda"
        );


    let botonGuardar = null;


    if (formulario) {

        botonGuardar =
            formulario.querySelector(
                '[type="submit"]'
            );

    }


    const textoOriginal =
        botonGuardar
            ? botonGuardar.innerHTML
            : "";


    if (botonGuardar) {

        botonGuardar.disabled = true;

        botonGuardar.innerHTML = `
            <span
                class="spinner-border spinner-border-sm me-2"
                role="status">
            </span>

            Guardando...
        `;

    }


    try {

        const respuesta =
            await fetch(
                "/tienda/guardar",
                {

                    method: "POST",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        if (!respuesta.ok) {

            let mensaje =
                `Error HTTP ${respuesta.status}`;


            try {

                const errorData =
                    await respuesta.json();


                mensaje =
                    errorData.mensaje ||
                    mensaje;


            } catch (errorJSON) {

                console.warn(
                    "⚠️ No se pudo convertir la respuesta de error a JSON"
                );

            }


            throw new Error(
                mensaje
            );

        }


        const resultado =
            await respuesta.json();


        console.log(
            "📦 Respuesta /tienda/guardar:",
            resultado
        );


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudo guardar el descuento"
            );

        }


        alert(
            resultado.mensaje ||
            "Descuento de tienda registrado correctamente"
        );


        const elemento =
            document.getElementById(
                "modalTienda"
            );


        if (
            elemento &&
            typeof bootstrap !==
            "undefined"
        ) {

            const modal =
                bootstrap.Modal.getInstance(
                    elemento
                );


            if (modal) {

                modal.hide();

            }

        }


        if (formulario) {

            formulario.reset();

        }


        limpiarDatosEmpleadoTienda();


        await cargarTienda();


    } catch (error) {

        console.error(
            "❌ Error al guardar descuento de tienda:",
            error
        );


        alert(
            error.message ||
            "Ocurrió un error al guardar el descuento de tienda."
        );


    } finally {

        if (botonGuardar) {

            botonGuardar.disabled = false;

            botonGuardar.innerHTML =
                textoOriginal;

        }

    }

}


// ============================================================
// ABRIR MODAL NUEVO DESCUENTO
// ============================================================

function abrirModalNuevoTienda() {

    console.log(
        "🟢 Abriendo modal Nuevo Descuento de Tienda"
    );


    const elemento =
        document.getElementById(
            "modalTienda"
        );


    if (!elemento) {

        console.error(
            "❌ No existe #modalTienda"
        );

        return;

    }


    const formulario =
        document.getElementById(
            "formTienda"
        );


    if (formulario) {

        formulario.reset();

    }


    limpiarDatosEmpleadoTienda();


    const select =
        document.getElementById(
            "idEmpleadoTienda"
        );


    if (select) {

        select.value = "";

    }


    const fecha =
        document.getElementById(
            "fechaTienda"
        );


    if (fecha) {

        const hoy =
            new Date();


        const año =
            hoy.getFullYear();


        const mes =
            String(
                hoy.getMonth() + 1
            ).padStart(
                2,
                "0"
            );


        const dia =
            String(
                hoy.getDate()
            ).padStart(
                2,
                "0"
            );


        fecha.value =
            `${año}-${mes}-${dia}`;

    }


    const estado =
        document.getElementById(
            "estadoTienda"
        );


    if (estado) {

        estado.value =
            "A";

    }


    if (
        typeof bootstrap ===
        "undefined"
    ) {

        console.error(
            "❌ Bootstrap no está cargado"
        );

        return;

    }


    const modal =
        bootstrap.Modal.getOrCreateInstance(
            elemento
        );


    modal.show();

}


// ============================================================
// LLENAR TABLA
// ============================================================

function llenarTablaTienda(
    registros = registrosTienda
) {

    const tbody =
        document.getElementById(
            "tbodyTienda"
        );


    if (!tbody) {

        console.error(
            "❌ No existe #tbodyTienda"
        );

        return;

    }


    tbody.innerHTML = "";


    if (
        !Array.isArray(registros) ||
        registros.length === 0
    ) {

        tbody.innerHTML = `
            <tr>

                <td
                    colspan="12"
                    class="empty-state">

                    <i
                        class="bi bi-shop d-block">
                    </i>

                    <div class="fw-semibold">

                        No hay descuentos de
                        tienda registrados

                    </div>

                    <small>

                        No existen registros
                        para mostrar.

                    </small>

                </td>

            </tr>
        `;

        return;

    }


    registros.forEach(
        registro => {

            const tr =
                document.createElement(
                    "tr"
                );


            const estado =
                String(
                    registro.ESTADO ?? ""
                ).toUpperCase();


            let estadoHTML = "";


            if (estado === "A") {

                estadoHTML = `
                    <span class="badge-activo">
                        Activo
                    </span>
                `;

            } else {

                estadoHTML = `
                    <span class="badge-inactivo">
                        Inactivo
                    </span>
                `;

            }


            const nombreEmpleado =
                registro.NOMBREEMPLEADO ?? "";


            const inicial =
                nombreEmpleado
                    .trim()
                    .charAt(0)
                    .toUpperCase() ||
                "?";


            tr.innerHTML = `

                <td>
                    ${registro.IDTIENDA ?? ""}
                </td>

                <td>
                    ${formatearFecha(
                        registro.FECHA
                    )}
                </td>

                <td>

                    <div
                        class="d-flex align-items-center">

                        <span
                            class="employee-avatar">

                            ${escapeHTML(
                                inicial
                            )}

                        </span>

                        <span
                            class="employee-name">

                            ${escapeHTML(
                                nombreEmpleado
                            )}

                        </span>

                    </div>

                </td>

                <td>
                    ${escapeHTML(
                        registro.DPI ?? ""
                    )}
                </td>

                <td>
                    ${escapeHTML(
                        registro.NOMBREPUESTO ?? ""
                    )}
                </td>

                <td>
                    ${escapeHTML(
                        registro.DIRECCION ?? ""
                    )}
                </td>

                <td>

                    <span class="tienda">

                        ${escapeHTML(
                            registro.NOMBRETIENDA ?? ""
                        )}

                    </span>

                </td>

                <td>

                    <span class="salary">

                        Q ${formatearNumero(
                            registro.SALARIOBASE
                        )}

                    </span>

                </td>

                <td>

                    <span class="descuento">

                        ${formatearNumero(
                            registro.DESCUENTO
                        )}%

                    </span>

                </td>

                <td>

                    <span class="pago">

                        Q ${formatearNumero(
                            registro.PAGOPORDESCUENTO
                        )}

                    </span>

                </td>

                <td>

                    ${estadoHTML}

                </td>

                <td>

                    <div
                        class="d-flex gap-2">

                        <button
                            type="button"
                            class="btn-accion btn-editar-tienda"
                            title="Editar"
                            onclick="editarTienda(
                                ${registro.IDTIENDA}
                            )">

                            <i
                                class="bi bi-pencil-square">
                            </i>

                        </button>


                        <button
                            type="button"
                            class="btn-accion btn-eliminar-tienda"
                            title="Eliminar"
                            onclick="eliminarTienda(
                                ${registro.IDTIENDA}
                            )">

                            <i
                                class="bi bi-trash">
                            </i>

                        </button>

                    </div>

                </td>

            `;


            tbody.appendChild(
                tr
            );

        }
    );

}


// ============================================================
// ACTUALIZAR RESUMEN
// ============================================================

function actualizarResumenTienda() {

    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    const totalDescuento =
        document.getElementById(
            "totalDescuento"
        );


    const totalPagoDescuento =
        document.getElementById(
            "totalPagoDescuento"
        );


    if (totalEmpleados) {

        const empleadosUnicos =
            new Set(
                registrosTienda.map(
                    registro =>
                        registro.DPI
                )
            );


        totalEmpleados.textContent =
            empleadosUnicos.size;

    }


    const sumaDescuentos =
        registrosTienda.reduce(
            (
                total,
                registro
            ) => {

                return total +
                    convertirNumero(
                        registro.DESCUENTO
                    );

            },
            0
        );


    if (totalDescuento) {

        totalDescuento.textContent =
            `${formatearNumero(
                sumaDescuentos
            )}%`;

    }


    const sumaPagos =
        registrosTienda.reduce(
            (
                total,
                registro
            ) => {

                return total +
                    convertirNumero(
                        registro.PAGOPORDESCUENTO
                    );

            },
            0
        );


    if (totalPagoDescuento) {

        totalPagoDescuento.textContent =
            `Q ${formatearNumero(
                sumaPagos
            )}`;

    }

}


// ============================================================
// BUSCAR
// ============================================================

function buscarTienda() {

    const input =
        document.getElementById(
            "buscarTienda"
        );


    if (!input) {
        return;
    }


    const texto =
        input.value
            .trim()
            .toLowerCase();


    if (!texto) {

        llenarTablaTienda(
            registrosTienda
        );

        return;

    }


    const filtrados =
        registrosTienda.filter(
            registro => {

                return [

                    registro.IDTIENDA,

                    registro.FECHA,

                    registro.NOMBREEMPLEADO,

                    registro.DPI,

                    registro.NOMBREPUESTO,

                    registro.DIRECCION,

                    registro.NOMBRETIENDA,

                    registro.SALARIOBASE,

                    registro.DESCUENTO,

                    registro.PAGOPORDESCUENTO,

                    registro.ESTADO

                ].some(
                    valor =>
                        String(
                            valor ?? ""
                        )
                            .toLowerCase()
                            .includes(
                                texto
                            )
                );

            }
        );


    llenarTablaTienda(
        filtrados
    );

}


// ============================================================
// LIMPIAR BÚSQUEDA
// ============================================================

function limpiarBusquedaTienda() {

    const input =
        document.getElementById(
            "buscarTienda"
        );


    if (input) {

        input.value = "";

    }


    llenarTablaTienda(
        registrosTienda
    );

}


// ============================================================
// FORMATEAR NÚMERO
// ============================================================

function formatearNumero(
    valor
) {

    const numero =
        convertirNumero(
            valor
        );


    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );

}


// ============================================================
// CONVERTIR NÚMERO
// ============================================================

function convertirNumero(
    valor
) {

    if (
        valor === null ||
        valor === undefined ||
        valor === ""
    ) {

        return 0;

    }


    const numero =
        Number(valor);


    return Number.isNaN(
        numero
    )
        ? 0
        : numero;

}


// ============================================================
// FORMATEAR FECHA
// ============================================================

function formatearFecha(
    fecha
) {

    if (!fecha) {
        return "";
    }


    const texto =
        String(fecha);


    if (
        /^\d{4}-\d{2}-\d{2}$/.test(
            texto
        )
    ) {

        const partes =
            texto.split("-");


        return `${partes[2]}/${partes[1]}/${partes[0]}`;

    }


    const fechaObjeto =
        new Date(fecha);


    if (
        Number.isNaN(
            fechaObjeto.getTime()
        )
    ) {

        return texto;

    }


    return fechaObjeto.toLocaleDateString(
        "es-GT"
    );

}


// ============================================================
// ESCAPAR HTML
// ============================================================

function escapeHTML(
    valor
) {

    return String(
        valor ?? ""
    )
        .replace(
            /&/g,
            "&amp;"
        )
        .replace(
            /</g,
            "&lt;"
        )
        .replace(
            />/g,
            "&gt;"
        )
        .replace(
            /"/g,
            "&quot;"
        )
        .replace(
            /'/g,
            "&#039;"
        );

}


// ============================================================
// EDITAR TIENDA
// ============================================================

function editarTienda(
    idTienda
) {

    const registro =
        registrosTienda.find(
            registro =>
                Number(
                    registro.IDTIENDA
                ) ===
                Number(
                    idTienda
                )
        );


    if (!registro) {

        console.error(
            "❌ No se encontró el registro:",
            idTienda
        );

        return;

    }


    console.log(
        "✏️ Registro seleccionado:",
        registro
    );


    const id =
        document.getElementById(
            "editarIdTienda"
        );


    if (id) {

        id.value =
            registro.IDTIENDA ?? "";

    }


    // ========================================================
    // OBTENER IDEMPLEADO
    //
    // La vista LISTARDESCUENTOSTIENDA debe incluir IDEMPLEADO.
    // Si no lo devuelve, se intenta obtener usando DPI.
    //
    // ========================================================

    let idEmpleadoRegistro =
        registro.IDEMPLEADO ?? "";


    if (
        !idEmpleadoRegistro &&
        registro.DPI
    ) {

        const empleado =
            empleadosTienda.find(
                empleado =>
                    String(
                        empleado.DPI ?? ""
                    ) ===
                    String(
                        registro.DPI ?? ""
                    )
            );


        if (empleado) {

            idEmpleadoRegistro =
                empleado.IDEMPLEADO;

        }

    }


    const idEmpleado =
        document.getElementById(
            "editarIdEmpleadoTienda"
        );


    if (idEmpleado) {

        idEmpleado.value =
            idEmpleadoRegistro;

    }


    const nombre =
        document.getElementById(
            "editarNombreEmpleadoTienda"
        );


    if (nombre) {

        nombre.value =
            registro.NOMBREEMPLEADO ?? "";

    }


    const dpi =
        document.getElementById(
            "editarDpiEmpleadoTienda"
        );


    if (dpi) {

        dpi.value =
            registro.DPI ?? "";

    }


    const puesto =
        document.getElementById(
            "editarPuestoEmpleadoTienda"
        );


    if (puesto) {

        puesto.value =
            registro.NOMBREPUESTO ?? "";

    }


    const direccion =
        document.getElementById(
            "editarDireccionEmpleadoTienda"
        );


    if (direccion) {

        direccion.value =
            registro.DIRECCION ?? "";

    }


    const nombreTienda =
        document.getElementById(
            "editarNombreTienda"
        );


    if (nombreTienda) {

        nombreTienda.value =
            registro.NOMBRETIENDA ?? "";

    }


    const salario =
        document.getElementById(
            "editarSalarioBaseTienda"
        );


    if (salario) {

        salario.value =
            registro.SALARIOBASE ?? "";

    }


    const descuento =
        document.getElementById(
            "editarDescuentoTienda"
        );


    if (descuento) {

        descuento.value =
            registro.DESCUENTO ?? "";

    }


    const pago =
        document.getElementById(
            "editarPagoPorDescuentoTienda"
        );


    if (pago) {

        pago.value =
            registro.PAGOPORDESCUENTO ?? "";

    }


    const fecha =
        document.getElementById(
            "editarFechaTienda"
        );


    if (fecha) {

        fecha.value =
            convertirFechaInput(
                registro.FECHA
            );

    }


    const estado =
        document.getElementById(
            "editarEstadoTienda"
        );


    if (estado) {

        estado.value =
            registro.ESTADO ?? "A";

    }


    const elemento =
        document.getElementById(
            "modalEditarTienda"
        );


    if (!elemento) {

        console.error(
            "❌ No existe #modalEditarTienda"
        );

        return;

    }


    if (
        typeof bootstrap ===
        "undefined"
    ) {

        console.error(
            "❌ Bootstrap no está cargado"
        );

        return;

    }


    const modal =
        bootstrap.Modal.getOrCreateInstance(
            elemento
        );


    modal.show();

}


// ============================================================
// CALCULAR PAGO POR DESCUENTO - EDITAR
// ============================================================

function calcularPagoDescuentoEditarTienda() {

    const salarioInput =
        document.getElementById(
            "editarSalarioBaseTienda"
        );


    const descuentoInput =
        document.getElementById(
            "editarDescuentoTienda"
        );


    const pagoInput =
        document.getElementById(
            "editarPagoPorDescuentoTienda"
        );


    if (
        !salarioInput ||
        !descuentoInput ||
        !pagoInput
    ) {

        return;

    }


    const salario =
        convertirNumero(
            salarioInput.value
        );


    const descuento =
        convertirNumero(
            descuentoInput.value
        );


    const pago =
        salario *
        (
            descuento /
            100
        );


    pagoInput.value =
        pago.toFixed(2);

}


// ============================================================
// ACTUALIZAR DESCUENTO DE TIENDA
//
// URL:
// PUT /tienda/actualizar
//
// PROCEDIMIENTO:
// dbo.SP_TIENDA_U
//
// PARÁMETROS:
// @IDTIENDA
// @NOMBRETIENDA
// @DESCUENTO
// @PAGOPORDESCUENTO
// @IDEMPLEADO
// @FECHA
//
// ============================================================

async function actualizarTienda() {

    console.log(
        "✏️ Iniciando actualización de descuento de tienda..."
    );


    // ========================================================
    // OBTENER CAMPOS
    // ========================================================

    const idTienda =
        document.getElementById(
            "editarIdTienda"
        );


    const idEmpleado =
        document.getElementById(
            "editarIdEmpleadoTienda"
        );


    const nombreTienda =
        document.getElementById(
            "editarNombreTienda"
        );


    const descuento =
        document.getElementById(
            "editarDescuentoTienda"
        );


    const pago =
        document.getElementById(
            "editarPagoPorDescuentoTienda"
        );


    const fecha =
        document.getElementById(
            "editarFechaTienda"
        );


    if (
        !idTienda ||
        !idEmpleado ||
        !nombreTienda ||
        !descuento ||
        !pago ||
        !fecha
    ) {

        console.error(
            "❌ Faltan campos del formulario de edición"
        );

        return;

    }


    // ========================================================
    // OBTENER VALORES
    // ========================================================

    const valorIdTienda =
        Number(
            idTienda.value
        );


    const valorIdEmpleado =
        Number(
            idEmpleado.value
        );


    const valorNombreTienda =
        nombreTienda.value.trim();


    const valorDescuento =
        convertirNumero(
            descuento.value
        );


    const valorPago =
        convertirNumero(
            pago.value
        );


    const valorFecha =
        fecha.value;


    // ========================================================
    // VALIDACIONES
    // ========================================================

    if (
        !valorIdTienda ||
        valorIdTienda <= 0
    ) {

        alert(
            "No se encontró el ID del descuento de tienda."
        );

        return;

    }


    if (
        !valorIdEmpleado ||
        valorIdEmpleado <= 0
    ) {

        alert(
            "No se encontró el empleado seleccionado."
        );

        return;

    }


    if (!valorNombreTienda) {

        alert(
            "Ingrese el nombre de la tienda."
        );

        nombreTienda.focus();

        return;

    }


    if (valorDescuento < 0) {

        alert(
            "Ingrese un porcentaje de descuento válido."
        );

        descuento.focus();

        return;

    }


    if (!valorFecha) {

        alert(
            "Seleccione la fecha."
        );

        fecha.focus();

        return;

    }


    // ========================================================
    // OBJETO PARA SP_TIENDA_U
    // ========================================================

    const datos = {

        IDTIENDA:
            valorIdTienda,

        NOMBRETIENDA:
            valorNombreTienda,

        DESCUENTO:
            valorDescuento,

        PAGOPORDESCUENTO:
            valorPago,

        IDEMPLEADO:
            valorIdEmpleado,

        FECHA:
            valorFecha

    };


    console.log(
        "📤 Datos enviados a /tienda/actualizar:",
        datos
    );


    // ========================================================
    // FORMULARIO
    // ========================================================

    const formulario =
        document.getElementById(
            "formEditarTienda"
        );


    let botonActualizar = null;


    if (formulario) {

        botonActualizar =
            formulario.querySelector(
                '[type="submit"]'
            );

    }


    const textoOriginal =
        botonActualizar
            ? botonActualizar.innerHTML
            : "";


    if (botonActualizar) {

        botonActualizar.disabled = true;

        botonActualizar.innerHTML = `
            <span
                class="spinner-border spinner-border-sm me-2"
                role="status">
            </span>

            Actualizando...
        `;

    }


    // ========================================================
    // ENVIAR AL SERVIDOR
    // ========================================================

    try {

        const respuesta =
            await fetch(
                "/tienda/actualizar",
                {

                    method: "PUT",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        // ====================================================
        // VALIDAR HTTP
        // ====================================================

        if (!respuesta.ok) {

            let mensaje =
                `Error HTTP ${respuesta.status}`;


            try {

                const errorData =
                    await respuesta.json();


                mensaje =
                    errorData.mensaje ||
                    mensaje;


            } catch (errorJSON) {

                console.warn(
                    "⚠️ La respuesta de error no es JSON"
                );

            }


            throw new Error(
                mensaje
            );

        }


        // ====================================================
        // CONVERTIR JSON
        // ====================================================

        const resultado =
            await respuesta.json();


        console.log(
            "📦 Respuesta /tienda/actualizar:",
            resultado
        );


        // ====================================================
        // VALIDAR RESULTADO
        // ====================================================

        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudo actualizar el descuento"
            );

        }


        // ====================================================
        // ÉXITO
        // ====================================================

        alert(
            resultado.mensaje ||
            "Descuento de tienda actualizado correctamente"
        );


        // ====================================================
        // CERRAR MODAL
        // ====================================================

        const elemento =
            document.getElementById(
                "modalEditarTienda"
            );


        if (
            elemento &&
            typeof bootstrap !==
            "undefined"
        ) {

            const modal =
                bootstrap.Modal.getInstance(
                    elemento
                );


            if (modal) {

                modal.hide();

            }

        }


        // ====================================================
        // RECARGAR TABLA
        // ====================================================

        await cargarTienda();


    } catch (error) {

        console.error(
            "❌ Error al actualizar descuento de tienda:",
            error
        );


        alert(
            error.message ||
            "Ocurrió un error al actualizar el descuento de tienda."
        );


    } finally {

        // ====================================================
        // RESTAURAR BOTÓN
        // ====================================================

        if (botonActualizar) {

            botonActualizar.disabled = false;

            botonActualizar.innerHTML =
                textoOriginal;

        }

    }

}


// ============================================================
// CONVERTIR FECHA PARA INPUT
// ============================================================

function convertirFechaInput(
    fecha
) {

    if (!fecha) {
        return "";
    }


    const texto =
        String(fecha);


    if (
        /^\d{4}-\d{2}-\d{2}$/.test(
            texto
        )
    ) {

        return texto;

    }


    const fechaObjeto =
        new Date(fecha);


    if (
        Number.isNaN(
            fechaObjeto.getTime()
        )
    ) {

        return "";

    }


    const año =
        fechaObjeto.getFullYear();


    const mes =
        String(
            fechaObjeto.getMonth() + 1
        ).padStart(
            2,
            "0"
        );


    const dia =
        String(
            fechaObjeto.getDate()
        ).padStart(
            2,
            "0"
        );


    return `${año}-${mes}-${dia}`;

}


// ============================================================
// ELIMINAR DESCUENTO DE TIENDA
//
// URL:
// DELETE /tienda/eliminar
//
// PROCEDIMIENTO:
// dbo.SP_TIENDA_D
//
// PARÁMETRO:
// @IDTIENDA
//
// IMPORTANTE:
// El procedimiento cambia ESTADO = 'I'.
// NO elimina físicamente el registro.
//
// ============================================================

async function eliminarTienda(
    idTienda
) {

    console.log(
        "🗑️ Iniciando eliminación de descuento de tienda:",
        idTienda
    );


    // ========================================================
    // BUSCAR REGISTRO
    // ========================================================

    const registro =
        registrosTienda.find(
            registro =>
                Number(
                    registro.IDTIENDA
                ) ===
                Number(
                    idTienda
                )
        );


    // ========================================================
    // VALIDAR REGISTRO
    // ========================================================

    if (!registro) {

        console.error(
            "❌ No se encontró el registro:",
            idTienda
        );

        alert(
            "No se encontró el descuento de tienda."
        );

        return;

    }


    console.log(
        "🗑️ Registro seleccionado para eliminar:",
        registro
    );


    // ========================================================
    // CONFIRMAR
    // ========================================================

    const confirmar =
        confirm(
            `¿Está seguro de eliminar el descuento de tienda ID ${idTienda}?`
        );


    if (!confirmar) {

        console.log(
            "ℹ️ Eliminación cancelada por el usuario."
        );

        return;

    }


    // ========================================================
    // DATOS
    //
    // dbo.SP_TIENDA_D
    //
    // @IDTIENDA INT
    //
    // ========================================================

    const datos = {

        IDTIENDA:
            Number(
                idTienda
            )

    };


    console.log(
        "📤 Datos enviados a /tienda/eliminar:",
        datos
    );


    // ========================================================
    // ENVIAR AL SERVIDOR
    // ========================================================

    try {

        const respuesta =
            await fetch(
                "/tienda/eliminar",
                {

                    method: "DELETE",

                    headers: {

                        "Content-Type":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        // ====================================================
        // VALIDAR HTTP
        // ====================================================

        if (!respuesta.ok) {

            let mensaje =
                `Error HTTP ${respuesta.status}`;


            try {

                const errorData =
                    await respuesta.json();


                mensaje =
                    errorData.mensaje ||
                    mensaje;


            } catch (errorJSON) {

                console.warn(
                    "⚠️ La respuesta de error no es JSON"
                );

            }


            throw new Error(
                mensaje
            );

        }


        // ====================================================
        // CONVERTIR RESPUESTA
        // ====================================================

        const resultado =
            await respuesta.json();


        console.log(
            "📦 Respuesta /tienda/eliminar:",
            resultado
        );


        // ====================================================
        // VALIDAR RESULTADO
        // ====================================================

        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudo eliminar el descuento de tienda"
            );

        }


        // ====================================================
        // ÉXITO
        // ====================================================

        alert(
            resultado.mensaje ||
            "Descuento de tienda eliminado correctamente"
        );


        // ====================================================
        // RECARGAR TABLA
        // ====================================================

        await cargarTienda();


    } catch (error) {

        console.error(
            "❌ Error al eliminar descuento de tienda:",
            error
        );


        alert(
            error.message ||
            "Ocurrió un error al eliminar el descuento de tienda."
        );

    }

}


// ============================================================
// EVENTOS
// ============================================================

document.addEventListener(
    "DOMContentLoaded",
    () => {

        console.log(
            "📄 DOM cargado para Tienda"
        );


        // ====================================================
        // INICIALIZAR
        // ====================================================

        inicializarTienda();


        // ====================================================
        // BOTÓN NUEVO
        // ====================================================

        const btnNuevo =
            document.getElementById(
                "btnNuevoTienda"
            );


        if (btnNuevo) {

            btnNuevo.addEventListener(
                "click",
                abrirModalNuevoTienda
            );


            console.log(
                "✅ Evento Nuevo Descuento conectado"
            );

        } else {

            console.error(
                "❌ No existe #btnNuevoTienda"
            );

        }


        // ====================================================
        // FORMULARIO GUARDAR
        // ====================================================

        const formularioTienda =
            document.getElementById(
                "formTienda"
            );


        if (formularioTienda) {

            formularioTienda.addEventListener(
                "submit",
                async event => {

                    event.preventDefault();

                    await guardarTienda();

                }
            );


            console.log(
                "✅ Evento guardar tienda conectado"
            );

        } else {

            console.error(
                "❌ No existe #formTienda"
            );

        }


        // ====================================================
        // FORMULARIO EDITAR
        // ====================================================

        const formularioEditarTienda =
            document.getElementById(
                "formEditarTienda"
            );


        if (formularioEditarTienda) {

            formularioEditarTienda.addEventListener(
                "submit",
                async event => {

                    event.preventDefault();

                    await actualizarTienda();

                }
            );


            console.log(
                "✅ Evento actualizar tienda conectado"
            );

        } else {

            console.warn(
                "⚠️ No existe #formEditarTienda"
            );

        }


        // ====================================================
        // DROPDOWN EMPLEADO
        // ====================================================

        const selectEmpleado =
            document.getElementById(
                "idEmpleadoTienda"
            );


        if (selectEmpleado) {

            selectEmpleado.addEventListener(
                "change",
                seleccionarEmpleadoTienda
            );


            console.log(
                "✅ Evento dropdown empleado conectado"
            );

        } else {

            console.error(
                "❌ No existe #idEmpleadoTienda"
            );

        }


        // ====================================================
        // INPUT DESCUENTO - NUEVO
        // ====================================================

        const descuentoTienda =
            document.getElementById(
                "descuentoTienda"
            );


        if (descuentoTienda) {

            descuentoTienda.addEventListener(
                "input",
                calcularPagoDescuentoTienda
            );

        }


        // ====================================================
        // INPUT DESCUENTO - EDITAR
        // ====================================================

        const editarDescuentoTienda =
            document.getElementById(
                "editarDescuentoTienda"
            );


        if (editarDescuentoTienda) {

            editarDescuentoTienda.addEventListener(
                "input",
                calcularPagoDescuentoEditarTienda
            );

        }


        // ====================================================
        // BUSCAR
        // ====================================================

        const buscar =
            document.getElementById(
                "buscarTienda"
            );


        if (buscar) {

            buscar.addEventListener(
                "input",
                buscarTienda
            );

        }


        // ====================================================
        // LIMPIAR BÚSQUEDA
        // ====================================================

        const limpiar =
            document.getElementById(
                "btnLimpiarBusqueda"
            );


        if (limpiar) {

            limpiar.addEventListener(
                "click",
                limpiarBusquedaTienda
            );

        }

    }
);


// ============================================================
// EXPORTAR FUNCIONES
// ============================================================

window.inicializarTienda =
    inicializarTienda;


window.cargarTienda =
    cargarTienda;


window.llenarTablaTienda =
    llenarTablaTienda;


window.cargarEmpleadosTienda =
    cargarEmpleadosTienda;


window.llenarSelectEmpleadosTienda =
    llenarSelectEmpleadosTienda;


window.obtenerEmpleadoTienda =
    obtenerEmpleadoTienda;


window.seleccionarEmpleadoTienda =
    seleccionarEmpleadoTienda;


window.limpiarDatosEmpleadoTienda =
    limpiarDatosEmpleadoTienda;


window.abrirModalNuevoTienda =
    abrirModalNuevoTienda;


window.calcularPagoDescuentoTienda =
    calcularPagoDescuentoTienda;


window.calcularPagoDescuentoEditarTienda =
    calcularPagoDescuentoEditarTienda;


window.guardarTienda =
    guardarTienda;


window.actualizarTienda =
    actualizarTienda;


window.editarTienda =
    editarTienda;


window.eliminarTienda =
    eliminarTienda;


window.buscarTienda =
    buscarTienda;


window.limpiarBusquedaTienda =
    limpiarBusquedaTienda;